module.exports = __webpack_public_path__ + "static/media/title_13.a60a9f70.svg";